export const SOCIAL_LINKS = {
  instagram: {
    label: "Instagram",
    href: "/social/instagram",
    external: "https://www.instagram.com/plymhair/",
  },
  facebook: {
    label: "Facebook",
    href: "/social/facebook",
    external: "https://www.facebook.com/plymhairextensions/",
  },
  tiktok: {
    label: "TikTok",
    href: "/social/tiktok",
    external: "https://www.tiktok.com/@plymhair",
  },
} as const;

export const WHATSAPP_NUMBER = "447919987503";
export const SALES_EMAIL = "tedd@plymhair.co.uk";

// Out-of-stock copy system
export const OUT_OF_STOCK_LABEL = "Coming Soon";
export const RESERVE_CTA_LABEL = "Want it sooner?";
export const RESERVE_MICROCOPY = "Limited release — secure yours before the next drop";

export type SocialPlatform = keyof typeof SOCIAL_LINKS;

export const isSocialPlatform = (value: string | undefined): value is SocialPlatform =>
  value !== undefined && value in SOCIAL_LINKS;
